import React from "react";
import { List, Button, Typography } from "antd";
import { NotificationType, notificationTypeMeta } from "./notificationTypes";

export type Notification = {
  _id: string;
  userId: string;
  type: NotificationType;
  message: string;
  read: boolean;
  createdAt: string;
  data?: any;
};

type Props = {
  notifications: Notification[];
  onMarkAsRead: (id: string) => void;
  onNotificationClick?: (notification: Notification) => void;
};

export const NotificationList: React.FC<Props> = ({ notifications, onMarkAsRead, onNotificationClick }) => (
  <List
    dataSource={notifications}
    renderItem={item => {
      const meta = notificationTypeMeta[item.type as keyof typeof notificationTypeMeta];
      const Icon = meta?.icon;
      return (
        <List.Item
          className={item.read ? "read" : "unread"}
          style={{
            cursor: "pointer",
            background: item.read ? "#fff" : "#f6f8fa",
            borderBottom: "1px solid #f0f0f0",
            padding: "16px 20px"
          }}
          onClick={() => {
            onMarkAsRead(item._id);
            onNotificationClick?.(item);
          }}
        >
          <List.Item.Meta
            avatar={Icon && React.createElement(Icon, { style: { color: meta.color, fontSize: 22 } })}
            title={
              <Typography.Text strong={!item.read} style={{ fontSize: 15 }}>
                {meta?.label || "Notification"}
              </Typography.Text>
            }
            description={
              <div>
                <div style={{ fontSize: 14 }}>{item.message}</div>
                <div style={{ fontSize: 12, color: "#888", marginTop: 2 }}>
                  {new Date(item.createdAt).toLocaleString()}
                </div>
              </div>
            }
          />
          {!item.read && (
            <Button size="small" onClick={e => { e.stopPropagation(); onMarkAsRead(item._id); }}>
              Mark as read
            </Button>
          )}
        </List.Item>
      );
    }}
    locale={{ emptyText: "No notifications" }}
    style={{ minWidth: 350, maxHeight: 400, overflow: "auto" }}
  />
);
